import { trackMixPanel } from '../../services/mixpanel.service';

export const reportViewLimitsScreen = (limitIncreaseDisplayed: boolean) => {
  trackMixPanel('View Limits Screen', {
    'Limit Increase displayed': limitIncreaseDisplayed,
  });
};

export const reportActOnLimitsScreen = (action: string) => {
  trackMixPanel('Act on Limits Screen', {
    Action: action,
  });
};

export const reportViewLimitsIncreaseBottomSheet = () => {
  trackMixPanel('View Limits Increase Bottom Sheet', {});
};

export const reportActOnLimitsIncreaseBottomSheet = (action: string) => {
  trackMixPanel('Act on Limits Increase Bottom Sheet', {
    Action: action,
  });
};
